import styled from 'styled-components'

export const CollapsibleInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray60};
  font-family: ${({ theme }) => theme.fonts.regular};
`

export const HeaderContainer = styled.div`
  display: flex;
  align-self: flex-start;
  align-items: baseline;
  cursor: pointer;

  > span {
    margin-left: 5px;
  }
`

export const Content = styled.p`
  margin-top: 5px;
`

export const StyledLabel = styled.label`
  font-family: ${({ theme }) => theme.fonts.semiBold};
`
